export default __webpack_public_path__ + "static/media/collapsible-app-bar-2.295276d6.png";